/** Trạng thái kết nối Zalo của phòng khám (Phase 5). Chỉ ĐỌC — không token, không secret. */
import { apiClient } from "./client";

/** OK / OFF / UNKNOWN. UNKNOWN nghĩa là không hỏi được, KHÁC với "chưa kết nối". */
export type ZaloLineState = "OK" | "OFF" | "UNKNOWN";

export interface ZaloLine {
  key: string;
  state: ZaloLineState;
  detail: string | null;
}

export interface ZaloStatus {
  tenantId: string;
  oa: ZaloLine;
  productionApp: ZaloLine;
  miniApp: ZaloLine;
  messaging: ZaloLine;
  sandbox: ZaloLine;
  addyMessageReachable: boolean;
  addySitesReachable: boolean;
  /** Đặt khi phòng khám chưa có tenant Addy Message — việc của quản trị viên nền tảng. */
  actionable: string | null;
}

export const zaloStatusQueryKeys = {
  mine: () => ["zalo-status", "mine"] as const,
  tenant: (tenantId: string) => ["zalo-status", tenantId] as const,
};

export const zaloStatusApi = {
  mine(): Promise<ZaloStatus> {
    return apiClient.get<ZaloStatus>("/v1/clinic/zalo/status").then((r) => r.data);
  },
  forTenant(tenantId: string): Promise<ZaloStatus> {
    return apiClient
      .get<ZaloStatus>(`/v1/platform/zalo-setup/${tenantId}/status`)
      .then((r) => r.data);
  },
};
